import style from "./scss/DropDownContainer.module.scss";
import {DropDownData, MainStore} from "../types";
import React from "react";
import {useSelector} from "react-redux";
import If from "./BaseComponent/If";

const CasinoDropDown = ({data}: DropDownData) => {
    const {generalTexts} = useSelector((state: MainStore) => state.casinoListSlice);
    const {
        index,
        features,
        id,
        bonusCondition,
        maxCashOutValue,
        paymentMethods,
        videoEmbedUrl,
        additionalInfo,
        minDepositValue,
        bonusInfo,
        wageringRequirements,
        externalAffiliateLink,
        reviewLink,
        internalAffiliateLink,
        casinoLogo,
        validFor
    } = data
    const imgProp = {"go-link-img": casinoLogo}
    return (
        <div
            className={`collapse ${style["item-dropdown-container"]}`}
            id={`collapse_${id}`}>
            <div className={style["dropdown-header"]}><span
                className={style.exclusive}>{generalTexts.exclusiveText}</span>
                <div className="dropdown-header-text">
                    {bonusCondition}<strong>{bonusInfo}</strong>&nbsp;{additionalInfo}
                </div>
            </div>
            <div className={`${style["item-dropdown-body"]} ${!videoEmbedUrl ? style['no-video'] : ''}`}>
                {features &&
                <div className={style["features-col"]}>
                    <ul>
                        {features.map((feature: string, index: number) =>
                            <li key={index}>
                                <div className={style["checkmark"]}>✓</div>
                                {feature}
                            </li>
                        )}
                    </ul>
                </div>
                }
                <If condition={!!validFor || !!wageringRequirements}>
                    <div className={style["validity-and-wagering"]}>
                        <If condition={!!validFor}>
                            <div className="valid-for">
                                <span className={style["pre-text"]}>{generalTexts.validForText}</span>
                                <span className={style["value-text"]}>{validFor}</span>
                            </div>
                        </If>
                        <If condition={!!wageringRequirements}>
                            <div className="wagering-requirements">
                                <span className={style["pre-text"]}>{generalTexts.wageringPrefix}</span>
                                <span className={style["value-text"]}>{wageringRequirements}</span>
                            </div>
                        </If>
                    </div>
                </If>
                {
                    minDepositValue && maxCashOutValue &&
                    <div className={style["min-deposit-max-cashout"]}>
                        <div className={style["min-deposit"]}>
                            <span className={style["pre-text"]}>{generalTexts.minDepositText}</span>
                            <span className={style["value-text"]}>{minDepositValue}</span>
                        </div>
                        <div className={style["max-cashout"]}>
                            <span className={style["pre-text"]}>{generalTexts.maxCashOutText}</span>
                            <span className={style["value-text"]}>{maxCashOutValue}</span>
                        </div>
                    </div>
                }
                {paymentMethods &&
                <div className={style["payment-methods"]}>
                    <p className={style["payment-method-title"]}>{generalTexts.paymentMethodText}</p>
                    <ul>
                        {paymentMethods.map((p) =>
                            <li key={p}>
                                <i className={`icon icon-${p} ${style['icon']}`}/>
                            </li>
                        )}
                    </ul>
                </div>
                }
                <If condition={!!videoEmbedUrl}>
                    <div className={style["video-embed"]}>
                        {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
                        <iframe className="lazy" id={`ytplayer_${id}`} width="640" height="360"
                                data-src={videoEmbedUrl}
                        />
                    </div>
                </If>
            </div>
            <div className={style["item-dropdown-footer"]}>
                <a href={reviewLink}
                   className="r-btn r-btn-empty">{generalTexts.reviewText}</a>
                {/* eslint-disable react/jsx-no-target-blank */}
                <a {...imgProp} data-aff={externalAffiliateLink} target="_blank" href={internalAffiliateLink}
                   data-table-position={index} className="r-btn go-link">{generalTexts.claimText}</a>
            </div>
        </div>
    )
}

export default CasinoDropDown;
